import React, { PureComponent } from 'react';

class BalanceView extends PureComponent {
  render() {
    const {
      balance,
      btcPrice,
    } = this.props;

    const totalBtc = balance * 0.00000001;
    const totalUsd = Math.round(totalBtc * btcPrice * 100) / 100

    return (
      <div className="balance-container">
        {balance === null ? (
          <div>loading...</div>
        ) : (
          <div>
            <div>
              Remaining Balance: <span>{totalBtc}</span> BTC / <span>{totalUsd}</span> USD
            </div>
          </div>
        )}
      </div>
    )
  }
}

export default BalanceView;



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/Offers/Balance/Balance.view.js